import React from 'react';
import s from '../../PromoBadge.scss';

export interface Props {
  className?: string;
}

const HexagonUnlocked40: React.FC<Props> = ({ className }) => (
  <svg className={className} width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.1"
      d="M19 .577a2 2 0 0 1 2 0l15.32 8.846a2 2 0 0 1 1 1.732v17.69a2 2 0 0 1-1 1.732L21 39.423a2 2 0 0 1-2 0L3.68 30.577a2 2 0 0 1-1-1.732v-17.69a2 2 0 0 1 1-1.732L19 .577Z"
      className={s['fill-color']}
    />
    <path
      opacity="0.1"
      d="M19 4.327a2 2 0 0 1 2 0l12.073 6.97a2 2 0 0 1 1 1.733v13.94a2 2 0 0 1-1 1.732L21 35.672a2 2 0 0 1-2 0l-12.073-6.97a2 2 0 0 1-1-1.732V13.03a2 2 0 0 1 1-1.732L19 4.328Z"
      className={s['fill-color']}
    />
    <path
      d="M19 8.077a2 2 0 0 1 2 0l8.825 5.096a2 2 0 0 1 1 1.732v10.19a2 2 0 0 1-1 1.732L21 31.923a2 2 0 0 1-2 0l-8.825-5.096a2 2 0 0 1-1-1.732v-10.19a2 2 0 0 1 1-1.732L19 8.077Z"
      className={s['fill-color']}
    />
  </svg>
);
HexagonUnlocked40.displayName = 'HexagonUnlocked40';

export default HexagonUnlocked40;
